/* eslint-disable react/prop-types */
import React from 'react';

const Select = ({
  name,
  error,
  label,
  value,
  options,
  touched,
  required,
  className,
  handleBlur,
  errorMessage,
  handleChange,
  defaultOption,
}) => (
  <>
    <div className={`form-outline mb-4 DashBoardInputBx${className ? ` ${className}` : ''}`}>
      <label id={name} className='form-label' htmlFor={name}>
        {label}
        {required && <span className='RedStar'>*</span>}
      </label>
      <select
        name={name}
        value={value}
        onBlur={handleBlur}
        onChange={handleChange}
        className={`form-select ${touched && error && 'input-error'}`}
      >
        <option value=''>{defaultOption}</option>
        {
          options.map(option => (
            <option key={option} value={option}>{option}</option>
          ))
        }
      </select>
      {
        touched && error && (
          <div className='text-danger'>{errorMessage}</div>
        )
      }
    </div>
  </>
);

export default Select;
